/* VIVID — transparent overlay header on the homepage.
   Header sits over the hero (transparent); goes solid on hover (CSS) and on scroll (.vivid-scrolled).
   Scoped to the homepage only. Re-applies on Theme Editor events so the editor preview matches live. */
(function () {
  var els = { wrapper: null, main: null };

  function isHome() {
    return document.body.classList.contains('template-index');
  }

  function getEls() {
    els.wrapper = document.querySelector('.header-wrapper');
    els.main = document.getElementById('MainContent');
  }

  function setOverlay() {
    if (!els.wrapper || !els.main) return;
    // Overlap is now done in CSS from first paint (vivid-brand.css: .section-header height 0 on desktop),
    // so nothing shifts after load. Clear any inline margin left by older code.
    els.main.style.marginTop = '';
  }

  function onScroll() {
    if (!els.wrapper) return;
    if (window.scrollY > 60) {
      els.wrapper.classList.add('vivid-scrolled');
    } else {
      els.wrapper.classList.remove('vivid-scrolled');
    }
  }

  function refresh() {
    if (!isHome()) return;
    getEls();
    if (!els.wrapper || !els.main) return;
    document.body.classList.add('vivid-transparent-header');
    requestAnimationFrame(function () {
      setOverlay();
      onScroll();
    });
  }

  function init() {
    if (!isHome()) return;
    refresh();
    window.addEventListener('resize', setOverlay, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    // Theme Editor: re-run when sections/blocks are added, removed, reordered or selected,
    // so the overlap + colour state stay accurate while editing.
    [
      'shopify:section:load',
      'shopify:section:unload',
      'shopify:section:reorder',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect',
    ].forEach(function (evt) {
      document.addEventListener(evt, refresh);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
